import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import api from '../services/api';

const GoogleAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loadUser, user } = useUser();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      setError('Authentication failed. Please try again.');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
      return;
    }

    if (token) {
      // Store the token
      localStorage.setItem('token', token);
      
      // Load the user data from backend and check if onboarding is needed
      loadUser().then(async () => {
        try {
          // Get user data directly from API to check if onboarding is needed
          const response = await api.getCurrentUser();
          console.log('🔍 User data response:', response);
          if (response.success && response.data && response.data.user) {
            const userData = response.data.user;
            console.log('🔍 User data:', userData);
            console.log('🔍 Username:', userData.username);
            // Check if user needs onboarding (no username set)
            if (!userData.username || userData.username === '') {
              console.log('🔄 Redirecting to onboarding...');
              navigate('/onboarding', { replace: true });
            } else {
              console.log('🏠 Redirecting to home...');
              console.log('🔍 Current location:', window.location.href);
              console.log('🔍 Navigating to:', '/');
              navigate('/', { replace: true });
            }
          } else {
            console.log('❌ No user data found, redirecting to home...');
            navigate('/', { replace: true });
          }
        } catch (error) {
          console.error('Error checking user data:', error);
          navigate('/', { replace: true });
        }
      }).catch((error) => {
        console.error('Error loading user:', error);
        navigate('/', { replace: true });
      });
    } else {
      setError('No authentication token received.');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    }
  }, [searchParams, navigate, loadUser]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h3 className="mt-2 text-sm font-medium text-gray-900">Authentication Error</h3>
            <p className="mt-1 text-sm text-gray-500">{error}</p>
            <p className="mt-2 text-sm text-gray-500">Redirecting to login...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
            <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="mt-2 text-sm font-medium text-gray-900">Authentication Successful</h3>
          <p className="mt-1 text-sm text-gray-500">Logging you in...</p>
          <div className="mt-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleAuthCallback; 